module.exports = __webpack_public_path__ + "static/media/free-charge-2x.eb426fe9.png";